var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.333,
    height: 16,
    viewBox: "0 0 13.333 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "document",
    d: "M10,4.667V.307a4.651,4.651,0,0,1,1.643,1.06l2.323,2.324a4.636,4.636,0,0,1,1.061,1.643h-4.36A.667.667,0,0,1,10,4.667ZM15.333,6.99v5.677A3.337,3.337,0,0,1,12,16H5.333A3.337,3.337,0,0,1,2,12.667V3.333A3.337,3.337,0,0,1,5.333,0h3.01c.109,0,.216.009.323.016V4.667a2,2,0,0,0,2,2h4.651c.007.107.016.215.016.323ZM10,12.667A.667.667,0,0,0,9.333,12H6a.667.667,0,0,0,0,1.333H9.333A.667.667,0,0,0,10,12.667ZM12,10a.667.667,0,0,0-.667-.667H6a.667.667,0,1,0,0,1.333h5.333A.667.667,0,0,0,12,10Z",
    transform: "translate(-2)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.687368f97765089f38e220d10f539c2e.svg";
export { ForwardRef as ReactComponent };